import { Breakpoints } from 'fukku/styles/breakpoints'
import type { ImagesSizes } from 'utils/image/types'

export const cardImageSizes: ImagesSizes[] = [
	{
		maxWidth: `${Breakpoints.large}px`,
		size: '40vw',
	},
	{
		maxWidth: `${Breakpoints.extraLarge}px`,
		size: '30vw',
	},
	{
		size: '25vw',
	},
]
